export const CURIOSO_NAMES = {
  MOOSEBEAR: 0,
  CATLIZARD: 1,
  BIRDRABBIT: 2,
}

export const PALETTES = [
  {
    light: '#96F3D4',
    dark: '#44CEA3',
  },
  {
    light: '#87E4FF',
    dark: '#4AB2FF',
  },
  {
    light: '#F5B1FF',
    dark: '#C880FF',
  },
  {
    light: '#FFB0D6',
    dark: '#FF72B2',
  },
  {
    light: '#FFB166',
    dark: '#FF8037',
  },
]